import { arrForEach } from "@microsoft/applicationinsights-core-js";
import dynamicProto from "@microsoft/dynamicproto-js";
import { tempStyle } from "./styleNodeSrc";
import { FilterList } from "./filterList";
import { LogEntry } from "./LogEntry";
import { copySelectedTree } from "./helpers";
var Dashboard = /** @class */ (function () {
    function Dashboard(config) {
        var _this = this;
        var msgTracker = [];
        var textFilter = "";
        /**
         * the root element of the logger
         */
        var rootElement;
        /**
         * the style that is only on the webpage when the log is active
         */
        var tempStyleEl;
        var filterList;
        var loggerEl;
        dynamicProto(Dashboard, this, function (_self) {
            var prefix = config.prefix;
            var trackers = config.trackers;
            var rootEl = rootElement = document.createElement("div");
            rootEl.className = prefix + "-dbg-lgr-dashboard";
            tempStyleEl = document.createElement("style");
            tempStyleEl.innerHTML = tempStyle(prefix);
            // TODO: research more accessibility (aria)
            rootEl.style.position = "fixed";
            rootEl.style.width = "100vw";
            rootEl.style.height = "100vh";
            rootEl.style.backgroundColor = "#ffffff";
            rootEl.style.opacity = "1";
            rootEl.style.pointerEvents = "auto";
            rootEl.style.top = "-100%";
            rootEl.style.transition = ".2s top cubic-bezier(0.87, 0, 0.13, 1)";
            var logHeading = document.createElement("h1");
            logHeading.textContent = "dashboard";
            logHeading.style.fontFamily = "monospace";
            logHeading.style.textAlign = "center";
            rootEl.appendChild(logHeading);
            _createLogger(rootEl, prefix, trackers);
            _self.getElm = function () {
                return rootEl;
            };
            _self.isDisplayed = function () {
                return !!(rootEl.parentElement || rootEl.parentNode);
            };
            _self.getTextFilter = function () {
                return textFilter;
            };
            _self.setTextFilter = function (value) {
                if (value !== textFilter) {
                    textFilter = value;
                    _self.render();
                }
            };
            _self.getTrackers = function () {
                return trackers;
            };
            _self.newLogEntry = function (target, tm, key, level, kind, keep) {
                var _self = _this;
                msgTracker.push(new LogEntry(target, tm, key, level, kind, keep));
                if (msgTracker.length > config.maxMessages) {
                    var lp = 0;
                    while (lp < msgTracker.length) {
                        var entry = msgTracker[lp];
                        if (!entry.isKeep()) {
                            var el = entry.getEl();
                            if (el && el.parentElement) {
                                el.parentElement.removeChild(el);
                            }
                            msgTracker.splice(lp, 1);
                            break;
                        }
                        lp++;
                    }
                }
                _self.render();
            };
            _self.show = function () {
                if (!_this.isDisplayed()) {
                    document.body.appendChild(rootEl);
                    document.head.appendChild(tempStyleEl);
                    rootEl.style.top = "0%";
                    rootEl.style.pointerEvents = "auto";
                    _self.render();
                }
            };
            _self.hide = function () {
                if (_self.isDisplayed()) {
                    rootEl.style.top = "-100%";
                    rootEl.style.pointerEvents = "none";
                    document.head.removeChild(tempStyleEl);
                    document.body.removeChild(rootEl);
                }
            };
            _self.render = function () {
                if (_self.isDisplayed()) {
                    var excludedTypes_1 = filterList.getCurrentFilter();
                    arrForEach(msgTracker, function (entry) {
                        var el = entry.getEl();
                        if (el && el.parentElement) {
                            el.parentElement.removeChild(el);
                        }
                        if (!entry.isMatch(textFilter, config.excludeKeys, config.includeFunctions)) {
                            return;
                        }
                        var type = entry.getKind();
                        var allowOther = excludedTypes_1.indexOf("other") === -1; // Other types are not excluded
                        if (trackers.indexOf(type) === -1 && !allowOther) {
                            // Not a tracked type and we are not allowing other types
                            return;
                        }
                        else if (excludedTypes_1.indexOf(type) !== -1) {
                            // This type is explicitly excluded
                            return;
                        }
                        var newEl = entry.render(textFilter, config.excludeKeys, config.includeFunctions);
                        if (newEl) {
                            loggerEl.appendChild(newEl);
                        }
                    });
                }
            };
            function clearEvents() {
                var newEvents = [];
                arrForEach(msgTracker, function (entry) {
                    if (entry.isKeep()) {
                        newEvents.push(entry);
                    }
                    else {
                        var el = entry.getEl();
                        if (el && el.parentElement) {
                            el.parentElement.removeChild(el);
                        }
                    }
                });
                msgTracker = newEvents;
                _self.render();
            }
            function closeDashboard() {
                _self.hide();
            }
            function _createLogger(hostDiv, prefix, trackers) {
                loggerEl = document.createElement("div");
                loggerEl.className = prefix + "-dbg-lgr";
                var controlDiv = document.createElement("div");
                controlDiv.className = "controls";
                var textFilterInput = document.createElement("input");
                textFilterInput.className = "text-filter-input";
                textFilterInput.setAttribute("placeholder", "filter text");
                textFilterInput.onchange = function (evt) {
                    _self.setTextFilter(textFilterInput.value);
                };
                textFilterInput.onblur = function (evt) {
                    _self.setTextFilter(textFilterInput.value);
                };
                textFilterInput.onkeyup = function (evt) {
                    if (keyupTimer != null) {
                        clearTimeout(keyupTimer);
                    }
                    var newValue = textFilterInput.value;
                    if (newValue !== _self.getTextFilter()) {
                        keyupTimer = setTimeout(function () {
                            keyupTimer = null;
                            _self.setTextFilter(textFilterInput.value);
                        }, 200);
                    }
                };
                controlDiv.appendChild(textFilterInput);
                var copyButton = document.createElement("button");
                copyButton.innerText = "copy current node";
                copyButton.className = "btn-secondary";
                copyButton.onclick = copySelectedTree;
                copyButton.ontouchend = copySelectedTree;
                var keyupTimer = null;
                filterList = new FilterList(controlDiv, trackers.slice(0), function () { return _self.render(); });
                controlDiv.appendChild(copyButton);
                var clearEventsBtn = document.createElement("button");
                clearEventsBtn.innerText = "clear events";
                clearEventsBtn.className = "btn-secondary";
                clearEventsBtn.onclick = clearEvents;
                clearEventsBtn.ontouchend = clearEvents;
                controlDiv.appendChild(clearEventsBtn);
                var closeEventsBtn = document.createElement("button");
                closeEventsBtn.id = "close-dashboard";
                closeEventsBtn.innerText = "close dashboard";
                closeEventsBtn.className = "btn-primary";
                closeEventsBtn.onclick = closeDashboard;
                closeEventsBtn.ontouchend = closeDashboard;
                controlDiv.appendChild(closeEventsBtn);
                hostDiv.appendChild(controlDiv);
                hostDiv.appendChild(loggerEl);
            }
        });
    }
    Dashboard.prototype.getElm = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    Dashboard.prototype.isDisplayed = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return false;
    };
    Dashboard.prototype.getTextFilter = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    Dashboard.prototype.setTextFilter = function (value) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    Dashboard.prototype.getTrackers = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
        return null;
    };
    Dashboard.prototype.newLogEntry = function (target, tm, key, level, kind, keep) {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    Dashboard.prototype.render = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    Dashboard.prototype.show = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    Dashboard.prototype.hide = function () {
        // @DynamicProtoStub -- DO NOT add any code as this will be removed during packaging
    };
    return Dashboard;
}());
export { Dashboard };
//# sourceMappingURL=Dashboard.js.map